import React, { useEffect, useState } from 'react'
import { useProjectStore } from '../../store/useProjectStore';

const ProjectIntroForm = () => {
    const [loading, setLoading] = useState(false)
    let { projectPage, getProjectForProjectPage, postProjectPageData } = useProjectStore()
    const [data, setData] = useState({
        subTitle: '',
        title: '',
        description: '',
    });

    const handleSubmit = async () => {
        setLoading(true)
        await postProjectPageData(data)
        setLoading(false)
    }

    useEffect(() => {
        if (projectPage) {
            setData({
                subTitle: projectPage.subTitle || '',
                title: projectPage.title || '',
                description: projectPage.description || '',
            })
        }
    }, [projectPage])
    return (
        <div>
            <div className="mb-6 space-y-6 bg-white">
                <div className="border border-neutral-200 rounded-md p-4">
                    <h4 className="mb-3">Hero Section</h4>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm text-neutral-700 mb-1">Sub Title</label>
                            <input
                                type="text"
                                value={data?.subTitle}
                                onChange={(e) => setData({ ...data, subTitle: e.target.value })}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-neutral-700 mb-1">Title</label>
                            <input
                                type="text"
                                value={data?.title}
                                onChange={(e) => setData({ ...data, title: e.target.value })}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                        <div>
                            <h4 className="mb-3">Description</h4>
                            <div>
                                <textarea
                                    rows="4"
                                    value={data?.description}
                                    onChange={(e) =>
                                        setData({ ...data, description: e.target.value })
                                    }
                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                />
                            </div>
                        </div>
                        <div className="flex justify-end items-center mb-6">
                            <button
                                className="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? (
                                    <div className="flex items-center gap-2">
                                        <svg
                                            className="animate-spin h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                            ></path>
                                        </svg>
                                        Processing...
                                    </div>
                                ) : (
                                    <>
                                        <i className="fa-solid fa-plus mr-2"></i>
                                        Submit
                                    </>
                                )}
                            </button>
                        </div>


                    </div>
                </div >
            </div >
        </div>
    )
}

export default ProjectIntroForm
